module.exports = __webpack_public_path__ + "img/119.4977e0a6.jpg";